import { Badge, BadgeVariant } from 'src/components/Badge';

export type CampaignStatus = 'draft' | 'scheduled' | 'running' | 'stopped';

interface CampaignBadgeProps {
  status: CampaignStatus;
  className?: string;
}

const statusConfig = {
  draft: {
    variant: 'info',
    color: 'bg-info',
    label: 'Draft',
  },
  scheduled: {
    variant: 'warning',
    color: 'bg-warning',
    label: 'Scheduled',
  },
  running: {
    variant: 'success',
    color: 'bg-success',
    label: 'Running',
  },
  stopped: {
    variant: 'error',
    color: 'bg-error',
    label: 'Stopped',
  },
};

export const CampaignBadge = ({
  status,
  className = '',
}: CampaignBadgeProps) => {
  const config = statusConfig[status];

  return (
    <Badge
      variant={config.variant as BadgeVariant}
      className={`flex items-center gap-1 ${className}`}
    >
      <div className={`w-2 h-2 ${config.color} rounded-full`}></div>
      {config.label}
    </Badge>
  );
};
